/**
 * Subclass of ModalShare from modal_share.js. Uses prototypal inhertance to
 * overwrite functions.  Specific to modal share in player from last screen.
 *
 * Config file should include the following properties:
 * @btnShare <selector> - Selector of the share button that should open the modal
 * @parentEl <selector> - Parent element/container that encapsulates share button(s)
 * @el <selector> - The parent modal element (usually an id)
*/

/**
 * Constructor for ModalShare object used in player
 * @config - configuration for this PlayerModalShare
 * @sslastscreen - the SSLastScreen that spawned the PlayerModalShare
*/
import ModalShare from './modal_share'

function PlayerModalShare (config, sslastscreen) {
  this.config = $.extend(config, sslastscreen.config);
  this.sslastscreen = sslastscreen;
  config && this.init();
  this.gaCategory = this.config.gaCategory ? this.config.gaCategory : sslastscreen.gaCategory;
}

// Set up prototypal inheritance
PlayerModalShare.prototype = new ModalShare();

PlayerModalShare.prototype.set_data = function() {
  this.data = {
      'ssLink': this.getNewSlideURL($('.j-share-social-list').data('canonical-url'), 1),
      'ssId': this.sslastscreen.config.slideshowId,
      'totalSlides': this.sslastscreen.config.totalSlides,
      'authorId': this.config.authorId
  };
  // Have to do this after data is set so that this.data.ssLink is defined
  // when it is (potentially) referenced in get_viral_share_urls
  this.data.social = this.get_viral_share_urls();

  // Used for share tracking
  this.SHARE_ABBRS = {
    facebook: 'fb',
    linkedin: 'li',
    twitter: 'tw',
    pinterest: 'pi'
  };

  this.renderSlideStartOptions();
};

/**
 * Set up player-specific modal share bindings
*/
PlayerModalShare.prototype.bindCustomModalEvents = function() {
  this.set_data();
};

/**
 * Close the modal share
*/
PlayerModalShare.prototype.close = function(){
  if ($("#svPlayerId").hasClass("infographic_player")) {
    $("body").removeClass("overflow_hidden");
  }
  this.reset();
  this.$container.hide();
  this.sslastscreen.restoreLastScreenState();
  this.sslastscreen.isShareScreenVisible = false;
  this.shareGATracking('modalClose');
};

PlayerModalShare.prototype.trackShareClick = function(network) {
  this.trackShareEvent({
    entityId: this.data.ssId,
    shareType: network,
    entityAuthorId: this.data.authorId,
    isEmbed: this.config.isEmbed
  });
  this.shareGATracking(this.SHARE_ABBRS[network], "share_open");
};

/**
 * Player GA Tracking helper
 * @value <String> - GA tracking value
*/
PlayerModalShare.prototype.shareGATracking = function(action, value) {
  if (typeof value !== 'undefined') {
    action = action + "_" + value;
  }
  $.slideshareEventManager.trackEvent(this.gaCategory + action);
};

// Fired when the user updates the 'start slide'
ModalShare.prototype.updateStartSlide = function() {
  var start_slide = $('.j-share-start-picker').prop("selectedIndex") + 1 || 1;
  if(start_slide <= 0) {
    return;
  }
  var that = this;
  // Update the data-urls of all the network share btns -- all of their URLs
  // should be the same, but in case this changes in the future we do this
  // (very light-weight) calculation for the new URL for each icon.
  $('.j-share-social-list li a').each(function(index) {
    var old_url = $(this).data('url');
    old_url && $(this).data('url', that.getNewSlideURL(old_url, start_slide));
  });
  this.data.ssLink = this.getNewSlideURL(this.data.ssLink, start_slide);
  $('#share-link-url').prop("value", this.getNewSlideURL($('#share-link-url').prop("value"), start_slide));
  $('.j-share-social-list li.pinterest a').data('media', this.getSlideImageURL(start_slide));
  $('.j-embed-start-picker').prop("selectedIndex", start_slide - 1);
  this.updateEmbed();
  this.data.social = this.get_viral_share_urls();
};

export default PlayerModalShare;